// utils/sanitize.js
const sanitize = (html) => {
  if (!html) return "";

  // on the server (SSR), DOMPurify can't run — return html as-is
  // since the content is already trusted from your own backend
  if (typeof window === "undefined") {
    return html;
  }

  // on the client, sanitize before rendering
  const DOMPurify = require("dompurify");
  return DOMPurify.sanitize(html, {
    ALLOWED_TAGS: [
      "p", "br", "strong", "b", "em", "i", "u", "s",
      "h1", "h2", "h3", "h4", "h5", "h6",
      "ul", "ol", "li", "blockquote", "pre", "code",
      "a", "img", "span", "div", "table", "thead",
      "tbody", "tr", "th", "td",
    ],
    ALLOWED_ATTR: ["href", "src", "alt", "class", "target", "rel", "width", "height"],
  });
};

export default sanitize;